import ModuleConfig from '../Config';
import Request from '../../../util/Api';
import { toaster } from 'evergreen-ui';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const Sidebar = ModuleConfig.Structures.Sidebar;
const CRUDActions = ModuleConfig.CRUDActions;

export function getSidebars(opts = { start: 0, limit: 0 }) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.sidebars,
        mapStructure: Sidebar,
        errorNotification: "Sidebar-urile nu au putut fi incarcate"
    });
}

export function getSidebar(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.sidebar,
        mapStructure: Sidebar,
        errorNotification: "Sidebar-ul nu a putut fi incarcat"
    })
}

export function createSidebar(values) {
    return CRUDActions.create(actions.create, {
        values,
        endpoint: endpoints.sidebars,
        mapStructure: Sidebar,
        successNotification: "Sidebar-ul a fost creat",
        nextUrl: '/sidebar/',
    })
}

export function updateSidebar(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.sidebar,
        mapStructure: Sidebar,
        successNotification: "Sidebar-ul a fost modificat",
        nextUrl: '/sidebar/',
    })
}

export function deleteSidebar(id) {
    return CRUDActions.remove(actions.delete, {
        id,
        endpoint: endpoints.sidebar,
        successNotification: "Sidebar-ul a fost sters",
        nextUrl: '/sidebar'
    });
}

export function setActiveSidebar(id) {
    return async (dispatch) => {
        dispatch({ type: actions.setActive.request.id });

        try {
            const response = await Request.post(endpoints.setActive.replace('[id]', id), {});

            if (response.success) {
                toaster.success("Sidebar-ul a fost activat");
                dispatch({
                    type: actions.setActive.success.id,
                    options: response.data
                });
                // Refresh the list
                dispatch(getSidebars());
            } else {
                toaster.danger("Sidebar-ul nu a putut fi activat");
                dispatch({
                    type: actions.setActive.failure.id,
                    options: response.error
                });
            }
        } catch (error) {
            toaster.danger("Eroare la activare sidebar");
            dispatch({
                type: actions.setActive.failure.id,
                options: error
            });
        }
    }
}
